import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=85b52b5e&scoped=true&"
import script from "./Timetable.vue?vue&type=script&lang=js&"
export * from "./Timetable.vue?vue&type=script&lang=js&"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=85b52b5e&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b52b5e",
  null
  
)

export default component.exports